import { FunctionComponent, Suspense, lazy } from 'react'

import { LoadingTurbo } from 'atoms'

import { RVCalculatorsSim2026Props } from './RVCalculatorsSim2026.types'
import { useRVCalculatorsSim2026 } from './useRVCalculatorsSim2026'

const RVCalculatorsSim2026Desktop = lazy(() => import('./RVCalculatorsSim2026.desktop'))

export const RVCalculatorsSim2026: FunctionComponent<RVCalculatorsSim2026Props> = (props) => {
  const RVCalculatorsSim2026 = useRVCalculatorsSim2026(props)

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <RVCalculatorsSim2026Desktop {...RVCalculatorsSim2026} />
    </Suspense>
  )
}
